import { useEffect, useState } from "react";
import { api, formatError } from "../../lib/api";

function decodeKey(base64) {
  const padding = "=".repeat((4 - base64.length % 4) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, c => c.charCodeAt(0));
}

export default function AdminPushSetup() {
  const [config, setConfig] = useState(null);
  const [configError, setConfigError] = useState("");
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  useEffect(() => {
    api.get("/admin/push/config").then(r => { setConfig(r.data); setConfigError(""); }).catch(e => {
      setConfig(null);
      setConfigError(e.response?.status === 401 ? "Session expirée : déconnectez-vous puis reconnectez-vous à NasDeal." : `Impossible de lire la configuration push : ${formatError(e)}`);
    });
    if (supported) navigator.serviceWorker.register("/sw.js").then(async registration => {
      const sub = await registration.pushManager.getSubscription();
      if (sub) setState("subscribed");
    }).catch(() => setMessage("Impossible d'installer le service de notifications."));
  }, [supported]);
  const subscribe = async () => {
    setMessage("");
    if (!supported || !config?.enabled) return;
    setState("loading");
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") { setState("idle"); setMessage("Autorisation refusée sur cet appareil."); return; }
      const registration = await navigator.serviceWorker.ready;
      const sub = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: decodeKey(config.public_key) });
      await api.post("/admin/push/subscribe", sub.toJSON());
      setState("subscribed");
      setMessage("Notifications push activées sur cet appareil.");
    } catch (error) { setState("idle"); setMessage(formatError(error)); }
  };
  const test = async () => {
    try { const { data } = await api.post("/admin/push/test"); setMessage(`Notification de test envoyée vers ${data.attempted} appareil(s). Vérifiez la réception.`); }
    catch (error) { setMessage(formatError(error)); }
  };
  const unsubscribe = async () => {
    setMessage("");
    try {
      const registration = await navigator.serviceWorker.ready;
      const sub = await registration.pushManager.getSubscription();
      if (sub) { await api.post("/admin/push/unsubscribe", sub.toJSON()); await sub.unsubscribe(); }
      setState("idle"); setMessage("Notifications désactivées sur cet appareil.");
    } catch (error) { setMessage(formatError(error)); }
  };
  return <div className="mb-5 border border-[#C9A45C]/30 rounded p-4 text-sm text-[#F8F6F1]/75">
    <p className="text-[#C9A45C] font-medium mb-2">Notifications iPhone même quand NasDeal est fermé</p>
    <p className="text-xs mb-3">Sur iPhone, ouvrez NasDeal dans Safari, utilisez Partager → Sur l'écran d'accueil, puis ouvrez l'application installée pour activer les alertes. iOS 16.4 minimum.</p>
    {!supported ? <p>Installez d'abord NasDeal sur l'écran d'accueil depuis Safari pour accéder aux notifications.</p> :
      configError ? <p role="alert" className="text-red-300">{configError}</p> :
      !config ? <p>Chargement de la configuration push…</p> :
      !config.enabled ? <p>Le serveur push n’est pas encore configuré.</p> :
      state === "subscribed" ? <span className="flex flex-wrap gap-2"><button type="button" onClick={test} className="btn-outline-gold !py-2">Envoyer une notification de test</button><button type="button" onClick={unsubscribe} className="btn-outline-gold !py-2">Désactiver les notifications push</button></span> :
      <button type="button" onClick={subscribe} disabled={state === "loading"} className="btn-outline-gold !py-2">{state === "loading" ? "Activation…" : "Activer les notifications push"}</button>}
    {message && <p className="mt-2" role="status">{message}</p>}
  </div>;
}
